import React, { useContext, useState, useEffect,useRef } from "react";
import CountUp from "react-countup";
import LazyLoad from "react-lazyload"; 
import { Collapse } from "react-bootstrap";
import { ExpertDashboardCounts, LoadExpertOffers, ExpertContractsLoad, LoadExpertJobs, LoadExpertProposals } from "../../utils/apiCalls";
import GlobalContext from "../../context/GlobalContext";
import Offers from "../../sections/ClientDashboard/Offers";
import Contract from "../../sections/ExpertDashboard/Contracts";
import ExpertJobs from "../../sections/ExpertDashboard/ExpertJobs";
import Proposals from "../../sections/ExpertDashboard/Proposal";
export default function DashboardMain() {
    const myRef = useRef();
    const gContext = useContext(GlobalContext);
    const [showJobs, setShowJobs] = useState("applied");
    const [showProposals, setShowProposals] = useState("open");
    const [showContracts, setShowContracts] = useState("new");
    const [showOffers, setShowOffers] = useState("new");
    const [jobsCount, setJobsCount] = useState(null);
    const [proposalCount, setProposalCount] = useState(null);
    const [contractCount, setContractCount] = useState(null);
    const [offersCount, setOffersCount] = useState(null); //offersCounts
    const [openItem, setOpenItem] = useState({ job: true, proposal: true, contract: true, offer: true });
    const [proposalDataList, setProposalDataList] = useState([]);
    const [offerDataList, setOfferDataList] = useState([]);
    const [contractDataList, setContractDataList] = useState([]);
    const [rowsJobs, setRowsJobs] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [loader, setLoader] = useState({ job: true, proposal: true, contract: true, offer: true });
    const offerRef = useRef();
    const propsalRef = useRef();
    const contractRef = useRef();
    async function LoadJobs(mode) {

        try {
            
            
            const result = await LoadExpertJobs(gContext.userInfo.userID, mode);

            if (result.data.loadExpertJobs.responseData.code == "200") {

                let data = JSON.parse(result.data.loadExpertJobs.responseData.message);
                
                if (mode == "saved")  
                    setRowsJobs(data?.saved);
                else
                    setRowsJobs(data?.applied);
            }  
            setLoader({ ...loader, ["job"]: true });
        }
        catch (e) {
            console.log(e);
            setLoader({ ...loader, ["job"]: true });
        }
    }
    async function BindProposals() {
        try {
           
            const result = await LoadExpertProposals(gContext.userInfo.userID);
            
            if (result.data.expertProposals.responseData.code == "200") {

                let data = JSON.parse(result.data.expertProposals.responseData.message);
               
                if (data) {
                    setProposalDataList(data);
                }
            }
            setLoader({ ...loader, ["proposal"]: true });
        }
        catch (e) {
            console.log(e);
            setLoader({ ...loader, ["proposal"]: true });
        }
    }
    async function BindOffers() {
        try {
            
            const result = await LoadExpertOffers(gContext.userInfo.userID);
            
            if (result.data.loadExpertOffers.responseData.code == "200") {

                let data = JSON.parse(result.data.loadExpertOffers.responseData.message);
                 
                if (data) {
                    setOfferDataList(data);
                }
            }
            setLoader({ ...loader, ["offer"]: true });
        }
        catch (e) {
            console.log(e);
            setLoader({ ...loader, ["offer"]: true });
        }
    }
    useEffect(() => {

        BindOffers(); ContractsLoad(); LoadJobs('applied');  BindProposals(); BindCounts();
    }, []);

    async function ContractsLoad() {
        try {
           
            const result = await ExpertContractsLoad(gContext.userInfo.userID);
         
            if (result.data.expertContractsLoad.responseData.code == "200") {

                let data = JSON.parse(result.data.expertContractsLoad.responseData.message);
                
                if (data) {
                  
                    setContractDataList(data);
                }
            }
            setLoader({ ...loader, ["contract"]: true });
        }
        catch (e) {
           
            setLoader({ ...loader, ["contract"]: true });
            console.log(e); gContext.setLoaderModalVisible(false);
        }
    }


    async function BindCounts() {
        try {

            const result = await ExpertDashboardCounts(gContext.userInfo.userID);

            if (result.data.expertDashboardCounts.responseData.code == "200") {

                let data = JSON.parse(result.data.expertDashboardCounts.responseData.message);
                
                if (data) {
                    setJobsCount(data.jobCounts);
                    setProposalCount(data.proposalCounts);
                    setContractCount(data.contractCounts);
                    setOffersCount(data.offersCounts);

                }
            }

            setTimeout(() => {
                setLoaded(true);
               
            }, 2000);
        }
        catch (e) {
            console.log(e);

        }
    }
    useEffect(() => {
        if (loaded) {
            gContext.setPageLoading(false);
            let hashLink = window.location.href.toLowerCase().replace(window.location.origin + "/dashboard#", "");
            setTimeout(() => {
                if (hashLink == "contracts")
                    contractRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
                else if (hashLink == "proposals")
                    propsalRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
                else if (hashLink == "offers")
                    offerRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });


            }, 1000);
        }
      
    }, [loaded]);

    useEffect(() => {  }, [])

    useEffect(() => {
        if (gContext.refreshDashboard == "proposal")
            BindProposals();
        if (gContext.refreshDashboard == "offer")
            BindOffers();
        if (gContext.refreshDashboard == "contract") { ContractsLoad(); }
        gContext.toggleRefreshDashboard("");
    }, [gContext.refreshDashboard]);

    useEffect(() => {
       
    }, [offerDataList]);

    useEffect(() => {
       
    }, [proposalDataList]);

    useEffect(() => {
         
    }, [contractDataList]);
    return (
        <>

            {loaded &&

                <>
                    <span className="screen-darken"></span>

                    <div className="page-wrapper">

                        <div className="section statics-block-wrapper">

                        <div className="container-fluid">

                            <div className="statistic-div-wrapper align-item-center justify-content-center">

                                <div className="statistic-div">
                                    <p className="m-b-10"><b>Applied Jobs</b></p>
                                    <div className="statistic-shape">
                                        <h3 className="value">{(jobsCount) ? jobsCount.applied : 0}</h3>
                                        <img className="statistic-icon" src="../images/dashboard-icons/jobs.svg" alt="Shape" />
                                        <img src="../images/dashboard-icons/statistic-shape-1.svg" alt="Shape" />
                                    </div>
                                </div>

                                <div className="statistic-div">
                                    <p className="m-b-10"><b>Saved Jobs</b></p>
                                    <div className="statistic-shape">
                                        <h3 className="value">{(jobsCount) ? jobsCount.saved : 0} </h3>
                                        <img className="statistic-icon" src="../images/dashboard-icons/jobs.svg" alt="jobs" />
                                        <img src="../images/dashboard-icons/statistic-shape-2.svg" alt="Shape" />
                                    </div>
                                </div>

                                <div className="statistic-div">
                                    <p className="m-b-10"><b>  Active Proposals</b></p>
                                    <div className="statistic-shape">
                                        <h3 className="value">{(proposalCount) ? proposalCount.active : 0} </h3>
                                        <img className="statistic-icon" src="../images/dashboard-icons/application.svg" alt="application" />
                                        <img src="../images/dashboard-icons/statistic-shape-3.svg" alt="Shape" />
                                    </div>
                                </div>

                               

                                <div className="statistic-div">
                                    <p className="m-b-10"><b>New Offers</b></p>
                                    <div className="statistic-shape">
                                        <h3 className="value">{(offersCount) ? offersCount.current : 0}</h3>
                                        <img className="statistic-icon" src="../images/dashboard-icons/offers.svg" alt="offers" />
                                        <img src="../images/dashboard-icons/statistic-shape-5.svg" alt="Shape" />
                                    </div>
                                </div>

                             
                                <div className="statistic-div">
                                    <p className="m-b-10"><b>Active Contracts</b></p>
                                    <div className="statistic-shape">
                                        <h3 className="value">{(contractCount) ? contractCount.active : 0}</h3>
                                        <img className="statistic-icon" src="../images/dashboard-icons/active-contract.svg" alt="active-contract" />
                                        <img src="../images/dashboard-icons/statistic-shape-7.svg" alt="Shape" />
                                    </div>
                                </div>

                                <div className="statistic-div">
                                    <p className="m-b-10"><b>Completed Contracts</b></p>
                                    <div className="statistic-shape">
                                        <h3 className="value">{(contractCount) ? contractCount.completed : 0}</h3>
                                        <img className="statistic-icon" src="../images/dashboard-icons/completed-contract.svg" alt="completed-contract" />
                                        <img src="../images/dashboard-icons/statistic-shape-8.svg" alt="Shape" />
                                    </div>
                                </div>

                                 
                            </div>
                                <div className="row d-none">

                                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no">
                                            <h3>{(jobsCount) ? jobsCount.applied : 0}</h3>
                                            <span className="statics-label">Applied Jobs</span>
                                            </div>

                                            <div className="statics-img">
                                                <img src="../images/statics-icon/msg-icon.svg" alt="msg-icon.svg" />
                                            </div>

                                            <img className="img-first" src="../images/statics-icon/msg-icon.svg" alt="msg-icon.svg" />

                                        </div>

                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no">
                                            <h3>{(jobsCount) ? jobsCount.saved : 0} </h3>
                                                <span className="statics-label">Saved Jobs</span>
                                            </div>

                                            <div className="statics-img">
                                                <img src="../images/statics-icon/user-icon-1.svg" alt="user-icon-1.svg" />
                                            </div>

                                            <img className="img-first" src="../images/statics-icon/user-icon-1.svg" alt="user-icon-1.svg" />

                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no">
                                            <h3>{(proposalCount) ? proposalCount.active : 0} </h3>
                                            <span className="statics-label">  Active  Proposals</span>
                                            </div>

                                            <div className="statics-img">
                                                <img src="../images/statics-icon/user-icon-2.svg" alt="user-icon-2.svg" />
                                            </div>

                                            <img className="img-first" src="../images/statics-icon/user-icon-2.svg" alt="user-icon-2.svg" />

                                        </div>
                                    </div>

                                    
                                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no">
                                            <h3>{(offersCount) ? offersCount.current : 0}</h3>
                                            <span className="statics-label"> New Offers</span>
                                            </div>

                                            <div className="statics-img">
                                                <img src="../images/statics-icon/user-icon-1.svg" alt="user-icon-1.svg" />
                                            </div>

                                            <img className="img-first" src="../images/statics-icon/user-icon-1.svg" alt="user-icon-1.svg" />

                                        </div>
                                    </div>

                                 

                                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no">
                                                <h3>{(contractCount) ? contractCount.active : 0}</h3>
                                                <span className="statics-label">Active Contracts</span>
                                            </div>

                                            <div className="statics-img">
                                                <img src="../images/statics-icon/list-icon.svg" alt="list-icon.svg" />
                                            </div>

                                            <img className="img-first" src="../images/statics-icon/list-icon.svg" alt="list-icon.svg" />

                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no">
                                            <h3>{(contractCount) ? contractCount.completed : 0}</h3>
                                                <span className="statics-label">Completes Contracts</span>
                                            </div>

                                            <div className="statics-img">
                                                <img src="../images/statics-icon/list-icon.svg" alt="list-icon.svg" />
                                            </div>

                                            <img className="img-first" src="../images/statics-icon/list-icon.svg" alt="list-icon.svg" />

                                        </div>
                                    </div>

                                     


                                </div>
                            </div>

                        </div>

                        <div className="section p-t-0">
                            <div className="container-fluid">
                            <div className="accordion" id="accordionExample1">
                                <div className="accordion-wrapper accordion-dashboard" id="jobs">

                                    <a className="accordion-btn  " data-bs-toggle="collapse" href="#accordion-job" aria-expanded="true" onClick={() => { setOpenItem({ ...openItem, ["job"]: !openItem.job }); setShowJobs('applied'); }}><h5>JOBS</h5>
                                            <span className="m-icon material-icons indicator show">expand_more</span>
                                            <span className="m-icon material-icons indicator hide">expand_less</span>
                                        </a>

                                        <div id="accordion-job" className="collapse show" data-bs-parent="#accordionExample">
                                            <div className="accordion-body card panel p-0">
                                                <div className="card-header">

                                                    <ul className="nav nav-tabs tab-light">
                                                        <li className="nav-item p-relative">
                                                        <a className={`nav-link pointer ${(showJobs == 'applied') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            setLoader({ ...loader, ["job"]: false });
                                                            setShowJobs('applied');
                                                            LoadJobs('applied');
                                                        }}>Applied</a>
                                                        </li>
                                                        <li className="nav-item p-relative">
                                                        <a className={`nav-link pointer ${(showJobs == 'saved') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            setLoader({ ...loader, ["job"]: false });
                                                            setShowJobs('saved');
                                                            LoadJobs('saved');


                                                        }}>Saved</a>
                                                        </li>
                                                        
                                                    </ul>

                                                <button type="button" className="btn btn-circle" onClick={() => { setLoader({ ...loader, ["job"]: false }); LoadJobs(showJobs); }} data-toggle="tooltip" title="Click here to refresh"><span className="text-theme m-icon material-icons m-r-10">refresh</span></button>

                                                </div>

                                                <div className="card-body">
                                                    <div className="tab-content">

                                                        <div className="tab-pane active" >
                                                             

                                                        {loader.job &&  < ExpertJobs mode={showJobs} rowsJobs={rowsJobs} updateData={(mode) => LoadJobs(mode)} /> }

                                                            {!loader.job &&
                                                                <div className="table-responsive">
                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr >
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>







                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            }
                                                        </div>



                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                             
                                <div className="accordion-wrapper accordion-dashboard" ref={propsalRef}  id="proposals">

                                    <a className="accordion-btn  " data-bs-toggle="collapse" href="#accordion-proposals" aria-expanded="true" onClick={() => { setOpenItem({ ...openItem, ["proposal"]: !openItem.proposal }); }}><h5>PROPOSALS</h5>
                                            <span className="m-icon material-icons indicator show">expand_more</span>
                                            <span className="m-icon material-icons indicator hide">expand_less</span>
                                        </a>

                                        <div id="accordion-proposals" className="collapse show" data-bs-parent="#accordionExample">
                                            <div className="accordion-body card panel p-0">
                                                <div className="card-header">

                                                    <div className="tab-light">
                                                        <ul className="nav nav-tabs">
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showProposals == 'open') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setShowProposals('open');

                                                            }}  >Submitted</a>
                                                            </li>
                                                            <li className="nav-item p-relative">
                                                            <a className={`nav-link pointer ${(showProposals == 'active') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                setShowProposals('active');
                                                                }}  >Active</a>
                                                            </li>
                                                            <li className="nav-item p-relative">
                                                            <a className={`nav-link pointer ${(showProposals == 'withdrawn') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                setShowProposals('withdrawn');

                                                            }}  >Withdrawn</a>
                                                            </li>                                                           
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showProposals == 'archived') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setShowProposals('archived');
                                                                }}  >Archived</a>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <button type="button" data-toggle="tooltip" title="Click here to refresh" className="btn btn-circle" onClick={() => { setLoader({ ...loader, ["proposal"]: false }); BindProposals() }}><span className="text-theme m-icon material-icons m-r-10">refresh</span></button>

                                                </div>

                                                <div className="tab-content">

                                                    <div className="tab-pane active" >
                                                        <div className="card-body"> 
                                                             
                                                        {loader.proposal &&  <Proposals mode={showProposals} proposalData={proposalDataList} callbackUpdateProposal={() => BindProposals()} /> }

                                                            {!loader.proposal &&
                                                                <div className="table-responsive">
                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr >
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>







                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            }

                                                        </div>
                                                    </div>


                                                </div>


                                            </div>
                                        </div>
                                    </div>
                               

                                <div className="accordion-wrapper accordion-dashboard" id="offers" ref={offerRef} >

                                    <a className="accordion-btn  " data-bs-toggle="collapse" href="#accordion-offers" aria-expanded="true" onClick={() => setOpenItem({ ...openItem, ["offer"]: !openItem.offer })}><h5>OFFERS</h5>
                                            <span className="m-icon material-icons indicator show">expand_more</span>
                                            <span className="m-icon material-icons indicator hide">expand_less</span>
                                        </a>

                                        <div id="accordion-offers" className="collapse show" data-bs-parent="#accordionExample">
                                            <div className="accordion-body card panel p-0">
                                                <div className="card-header">

                                                    <div className="tab-light">
                                                        <ul className="nav nav-tabs">
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showOffers == 'new') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setShowOffers('new');

                                                                }}>New</a>
                                                            </li>
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showOffers == 'Accepted') ? 'active' : ' '}`} href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setShowOffers('Accepted');

                                                                    }}>Accepted</a>
                                                            </li>
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showOffers == 'Rejected') ? 'active' : ' '}`} href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setShowOffers('Rejected');

                                                                    }}>Rejected</a>
                                                            </li>
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showOffers == 'Expired') ? 'active' : ' '}`} href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setShowOffers('Expired');

                                                                    }}>Expired</a>
                                                            </li>
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showOffers == 'Withdrawn') ? 'active' : ' '}`} href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setShowOffers('Withdrawn');

                                                                    }}>Withdrawn</a>
                                                            </li>
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showOffers == 'Archived') ? 'active' : ' '}`} href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setShowOffers('Archived');

                                                                    }}>Archived</a>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <button type="button" className="btn btn-circle" data-toggle="tooltip" title="Click here to refresh" onClick={() => { setLoader({ ...loader, ["offer"]: false }); BindOffers() }}><span className="text-theme m-icon material-icons m-r-10">refresh</span></button>

                                                </div>

                                                <div className="tab-content">

                                                    <div className="tab-pane active" >
                                                        <div className="card-body">
                                                        {loader.offer &&  < Offers proposalData={proposalDataList} mode={showOffers} offerData={offerDataList} callbackUpdateOffer={() => BindOffers()} /> }
                                                            {!loader.offer &&
                                                                <div className="table-responsive">
                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr >
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>







                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            }

                                                        </div>
                                                    </div>



                                                </div>


                                            </div>
                                        </div>
                                </div>
                               
                            </div>
                          
                            <div className="accordion-wrapper accordion-dashboard" id="contracts" ref={contractRef}>
                                    <a className="accordion-btn  " data-bs-toggle="collapse" href="#accordion-contracts" aria-expanded="true" onClick={() => setOpenItem({ ...openItem, ["contract"]: !openItem.contract })}><h5>CONTRACTS</h5>
                                            <span className="m-icon material-icons indicator show">expand_more</span>
                                            <span className="m-icon material-icons indicator hide">expand_less</span>
                                        </a>

                                        <div id="accordion-contracts" className="collapse show" data-bs-parent="#accordionExample">
                                            <div className="accordion-body card panel p-0">
                                                <div className="card-header">

                                                    <div className="tab-light">
                                                        <ul className="nav nav-tabs">
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showContracts == 'new') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setShowContracts('new');

                                                                }}>
                                                                    New</a>
                                                            </li>
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showContracts == 'Active') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setShowContracts('Active');

                                                                }}>
                                                                    Active</a>
                                                            </li>
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showContracts == 'Completed') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setShowContracts('Completed');

                                                                }}>
                                                                    Completed</a>
                                                            </li>
                                                            <li className="nav-item p-relative">
                                                                <a className={`nav-link pointer ${(showContracts == 'Terminated') ? 'active' : ' '}`} href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setShowContracts('Terminated');

                                                                }}>
                                                                    Terminated</a>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                <button type="button" className="btn btn-circle" data-toggle="tooltip" title="Click here to refresh" onClick={() => { setLoader({ ...loader, ["contract"]: false }); ContractsLoad() }} ><span className="text-theme m-icon material-icons m-r-10">refresh</span></button>

                                                </div>

                                                <div className="tab-content">

                                                    <div className="tab-pane active" >
                                                        <div className="card-body">
                                                        {loader.contract &&  <Contract mode={showContracts} contractData={contractDataList} /> }
                                                            {!loader.contract &&
                                                                <div className="table-responsive">
                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr >
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                                <th className="w-130 movingLoader "> </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>
                                                                                <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>  <td className="w-130 movingLoader ">
                                                                                </td>
                                                                            </tr>







                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            }

                                                        </div>
                                                    </div>



                                                </div>


                                            </div>
                                        </div>
                                </div>
                              
                                </div>
                            </div>
                        </div>

                  
                 
</>

            }
            {!loaded &&
                <>
                    <span className="screen-darken"></span>

                    <div className="page-wrapper">

                        <div className="section statics-block-wrapper">

                            <div className="container-fluid">
                                <div className="row">

                                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no  ">
                                                <h3 className=" w-200 movingLoader"> &nbsp; </h3>
                                                <span className=" w-200 movingLoader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                                            </div>




                                        </div>

                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no  ">
                                                <h3 className=" w-200 movingLoader"> &nbsp; </h3>
                                                <span className=" w-200 movingLoader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                                            </div>




                                        </div>

                                    </div><div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no  ">
                                                <h3 className=" w-200 movingLoader"> &nbsp; </h3>
                                                <span className=" w-200 movingLoader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                                            </div>




                                        </div>

                                    </div><div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no  ">
                                                <h3 className=" w-200 movingLoader"> &nbsp; </h3>
                                                <span className=" w-200 movingLoader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                                            </div>




                                        </div>

                                    </div><div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no  ">
                                                <h3 className=" w-200 movingLoader"> &nbsp; </h3>
                                                <span className=" w-200 movingLoader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                                            </div>




                                        </div>

                                    </div><div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no  ">
                                                <h3 className=" w-200 movingLoader"> &nbsp; </h3>
                                                <span className=" w-200 movingLoader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                                            </div>




                                        </div>

                                    </div><div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no  ">
                                                <h3 className=" w-200 movingLoader"> &nbsp; </h3>
                                                <span className=" w-200 movingLoader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                                            </div>




                                        </div>

                                    </div><div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                        <div className="card statics-block">

                                            <div className="statics-no  ">
                                                <h3 className=" w-200 movingLoader"> &nbsp; </h3>
                                                <span className=" w-200 movingLoader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
                                            </div>




                                        </div>

                                    </div>



                                </div>
                            </div>

                        </div>

                        <div className="section p-t-0">
                            <div className="container-fluid">
                                <div className="accordion" id="accordionExample">
                                    <div className="accordion-wrapper accordion-dashboard">

                                        <a className="accordion-btn movingLoader" data-bs-toggle="collapse" href="#accordion-job" aria-expanded="true"  >&nbsp;
                                            <span className="m-icon material-icons indicator show">expand_more</span>
                                            <span className="m-icon material-icons indicator hide">expand_less</span>
                                        </a>

                                        <div id="accordion-job" className="collapse show" data-bs-parent="#accordionExample">
                                            <div className="accordion-body card panel p-0">
                                                <div className="card-header">

                                                    <ul className="nav nav-tabs tab-light">
                                                        <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li> <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li> <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li>
                                                        <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li>
                                                    </ul>



                                                </div>

                                                <div className="card-body">
                                                    <div className="tab-content">

                                                        <div className="tab-pane active" >


                                                            <div className="table-responsive">
                                                                <table className="table table-striped">
                                                                    <thead>
                                                                        <tr >
                                                                            <th className="w-130 movingLoader "> </th>
                                                                            <th className="w-130 movingLoader "> </th>
                                                                            <th className="w-130 movingLoader "> </th>
                                                                            <th className="w-130 movingLoader "> </th>
                                                                            <th className="w-130 movingLoader "> </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>
                                                                        </tr>







                                                                    </tbody>
                                                                </table>
                                                            </div>


                                                        </div>



                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-wrapper accordion-dashboard">

                                        <a className="accordion-btn movingLoader" data-bs-toggle="collapse" href="#accordion-job" aria-expanded="true"  >&nbsp;
                                            <span className="m-icon material-icons indicator show">expand_more</span>
                                            <span className="m-icon material-icons indicator hide">expand_less</span>
                                        </a>

                                        <div id="accordion-job" className="collapse show" data-bs-parent="#accordionExample">
                                            <div className="accordion-body card panel p-0">
                                                <div className="card-header">

                                                    <ul className="nav nav-tabs tab-light">
                                                        <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li> <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li> <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li>
                                                        <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li>
                                                    </ul>



                                                </div>

                                                <div className="card-body">
                                                    <div className="tab-content">

                                                        <div className="tab-pane active" >


                                                            <div className="table-responsive">
                                                                <table className="table table-striped">
                                                                    <thead>
                                                                        <tr >
                                                                            <th className="w-130   "> </th>
                                                                            <th className="w-130    "> </th>
                                                                            <th className="w-130   "> </th>
                                                                            <th className="w-130    "> </th>
                                                                            <th className="w-130   "> </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="w-130   ">
                                                                            </td>
                                                                            <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="w-130   ">
                                                                            </td>
                                                                            <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>
                                                                        </tr>







                                                                    </tbody>
                                                                </table>
                                                            </div>


                                                        </div>



                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div><div className="accordion-wrapper accordion-dashboard">

                                        <a className="accordion-btn movingLoader" data-bs-toggle="collapse" href="#accordion-job" aria-expanded="true"  >&nbsp;
                                            <span className="m-icon material-icons indicator show">expand_more</span>
                                            <span className="m-icon material-icons indicator hide">expand_less</span>
                                        </a>

                                        <div id="accordion-job" className="collapse show" data-bs-parent="#accordionExample">
                                            <div className="accordion-body card panel p-0">
                                                <div className="card-header">

                                                    <ul className="nav nav-tabs tab-light">
                                                        <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li> <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li> <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li>
                                                        <li className="nav-item p-relative movingLoader w-100">
                                                            <a className={`nav-link pointer `} >&nbsp;</a>
                                                        </li>
                                                    </ul>


                                                </div>

                                                <div className="card-body">
                                                    <div className="tab-content">

                                                        <div className="tab-pane active" >


                                                            <div className="table-responsive">
                                                                <table className="table table-striped">
                                                                    <thead>
                                                                        <tr >
                                                                            <th className="w-130   "> </th>
                                                                            <th className="w-130    "> </th>
                                                                            <th className="w-130   "> </th>
                                                                            <th className="w-130    "> </th>
                                                                            <th className="w-130   "> </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="w-130   ">
                                                                            </td>
                                                                            <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>
                                                                            <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>  <td className="w-130 movingLoader ">
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="w-130   ">
                                                                            </td>
                                                                            <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>  <td className="w-130   ">
                                                                            </td>
                                                                        </tr>







                                                                    </tbody>
                                                                </table>
                                                            </div>


                                                        </div>



                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>







                                </div>
                            </div>
                        </div>

                    </div>

                </>   }

        </>
    );
};